
<template>
    <div>
        <div class="row">
            <div class="col-xl-12 order-xl-1">
                <template>
                    <tabs fill class="flex-column flex-md-row">
                        <card shadow>
                            <tab-pane 
                                title="Pending Applications"
                                @tab-activated="triggerPendingApplications" 
                            >
                                <span slot="title">
                                    <i class="ni ni-books"></i>
                                    Pending Applications
                                </span>
                                <!-- import Pending Applications template here -->
                                <PendingApplications 
                                    :visitStatus="'no'"
                                    ref="callPendingApplications"
                                />
                            </tab-pane>

                            <tab-pane 
                                title="Verification Visit"
                                @tab-activated="triggerVisitApplications"
                            >
                                <span slot="title">
                                    <i class="ni ni-archive-2"></i>
                                    Verification Visit
                                </span>
                                <!-- import Verification Visit template here -->
                                <PendingApplications 
                                    :visitStatus="'yes'"
                                    ref="callVisitApplications"
                                />
                            </tab-pane>

                            <tab-pane 
                                title="Rejected Applications"
                                @tab-activated="triggerRejectedApplications"
                            >
                                <span slot="title">
                                    <i class="ni ni-badge"></i>
                                    Rejected Applications
                                </span>
                                <!-- import Rejected Applications template here -->
                                <RejectedApplications 
                                    :status="'rejected'"
                                    ref="callRejectedApplications"
                                />
                            </tab-pane>

                            <tab-pane 
                                title="Completed Applications"
                                @tab-activated="triggerCompletedApplications"
                            >
                                <span slot="title">
                                    <i class="ni ni-archive-2"></i>
                                    Completed Applications
                                </span>
                                <!-- import Completed Applications template here -->
                                <CompletedApplications 
                                    ref="callCompletedApplications"
                                />
                            </tab-pane>

                            <tab-pane 
                                title="Incomplete Applications"
                                @tab-activated="triggerIncompleteApplications"
                            >
                                <span slot="title">
                                    <i class="ni ni-badge"></i>
                                    Incomplete Applications
                                </span>
                                <!-- import Rejected Applications template here -->
                                <RejectedApplications 
                                    :status="'pending'"
                                    ref="callIncompleteApplications"
                                />
                            </tab-pane>

                        </card>
                    </tabs>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import PendingApplications from './Applications/PendingApplications';
    import RejectedApplications from './Applications/RejectedApplications';
    import CompletedApplications from './Applications/CompletedApplications';

    export default {
        name: 'Applications',
        props: ['changeTitle', 'privileges'],
        components: {
            PendingApplications,
            RejectedApplications,
            CompletedApplications
        },
        methods: {
            makeTitle() {
                let title = 'Training Hospital Applications';
                return this.changeTitle(title, true);
            },
            triggerPendingApplications() {
                if (this.$refs.callPendingApplications && this.$refs.callPendingApplications.loadAplications) {
                    this.$refs.callPendingApplications.loadAplications();
                }
            },
            triggerVisitApplications() {
                if (this.$refs.callVisitApplications && this.$refs.callVisitApplications.loadAplications) {
                    this.$refs.callVisitApplications.loadAplications();
                }
            },
            triggerRejectedApplications() {
                if (this.$refs.callRejectedApplications && this.$refs.callRejectedApplications.loadAplications) {
                    this.$refs.callRejectedApplications.loadAplications();
                }
            },
            triggerCompletedApplications() {
                if (this.$refs.callCompletedApplications && this.$refs.callCompletedApplications.loadAplications) {
                    this.$refs.callCompletedApplications.loadAplications();
                }
            },
            triggerIncompleteApplications() {
                if (this.$refs.callIncompleteApplications && this.$refs.callIncompleteApplications.loadAplications) {
                    this.$refs.callIncompleteApplications.loadAplications();
                }
            }
        },
        created() {
            this.makeTitle();
        }
    };
</script>
<style></style>
